import { Stack } from '@mui/material';

import { Typography } from '@/design-system';

import { NON_ACCREDITED_TOOLTIP } from './data';

const NonAccreditedContent = () => (
  <Stack
    maxWidth="560px"
    alignItems="center"
    gap="12px"
    textAlign="center"
    sx={{ flexDirection: 'column' }}
  >
    <Typography variant="h6">Reserved for accredited investors</Typography>
    <Typography variant="body3">{NON_ACCREDITED_TOOLTIP}</Typography>
  </Stack>
);

export const NonAccreditedSection = () => {
  return (
    <Stack
      flex={1}
      width="100%"
      minHeight="60vh"
      alignItems="center"
      justifyContent="center"
      padding="24px"
      sx={{ flexDirection: 'column' }}
    >
      <NonAccreditedContent />
    </Stack>
  );
};

export const NonAccreditedDisclaimer = () => {
  return (
    <Stack
      width="100%"
      alignItems="center"
      justifyContent="center"
      padding="40px 24px"
      sx={{ flexDirection: 'column' }}
    >
      <NonAccreditedContent />
    </Stack>
  );
};
